import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, AccordionTitle } from './HistoryListTitle.styled';
import { isAddOrUpdate } from './historyEventsHelpers';

const HistoryListTitle = ({ count, eventType, user }) => {
  const isAddAction = isAddOrUpdate(eventType);
  return (
    <>
      <Avatar isAddAction={isAddAction}>{`${
        isAddAction ? '+' : '-'
      }${count}`}</Avatar>
      <AccordionTitle
        isAddAction={isAddAction}
      >{`${count} users were ${eventType} by ${user}`}</AccordionTitle>
    </>
  );
};

HistoryListTitle.propTypes = {
  count: PropTypes.number.isRequired,
  eventType: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
};

export default HistoryListTitle;
